import * as React from 'react'

import '../styles/ReviewTitle.scss'

interface ReviewTitleProps {
    title: string
    subTitle?: string
}

export class ReviewTitle extends React.Component<ReviewTitleProps, {}> {

    constructor(props: any) {
        super(props)
    }

    render() {
        return (
            <div className="reviewTitle">
                <div className="reviewTitle">
                    <span>{this.props.title}</span>
                </div>
                <div className="reviewSubtitle">
                    <span>{this.props.subTitle ? this.props.subTitle : ''}</span>
                </div>
            </div>)
    }
}



// WEBPACK FOOTER //
// ./src/components/ReviewTitle.tsx